"use client";
import { Typography } from "antd";
import Image from "next/image";
import Link from "next/link";
import React from "react";

import { contactInfo } from "@/app/contents/contactInformation";

import Logo from "../logo/logo";

import {
  PermissionsContents,
  QuickAccessContents,
  SocialMediaContents,
} from "./contents";
import EnamadBadge from "./EnamadBadge";
import MembershipForm from "./membershipForm";





const Footer = () => {
  const { Title } = Typography;

  return (
    <div className="bg-footer w-full">
      <div className="container py-8 sm:flex-row sm:flex-wrap sm:justify-between h-auto flex flex-col gap-8 items-center sm:items-start justify-center">
        <div className="flex flex-col gap-4 w-full mid:w-[30%]">
          <Logo className="filter invert brightness-0" />
          <p className="text-white !text-sm !leading-8">
            تابرق به‌ عنوان وارد کننده مستقیم پنل‌های خورشیدی، محصولات خود را با
            بالاترین استانداردهای جهانی به بازار عرضه می‌کند. این شرکت با حذف
            واسطه‌ها، تجهیزات اصل را با قیمتی رقابتی و شفاف در اختیار مشتریان
            قرار می‌دهد. وجه تمایز فراناب، ارائه ترکیبی از کیفیت برتر، قیمت
            منصفانه و پشتیبانی پایدار است.
          </p>
        </div>
        <div className="flex justify-center w-full sm:w-[47%] mid:!w-[20%]">
          <div className="flex flex-col gap-4 w-full mid:!w-[70%]">
            <Title level={2} className="H2 xl:!text-2xl whiteColor-text">
              دسترسی سریع
            </Title>
            {QuickAccessContents.map((QuickAccess) => (
              QuickAccess.isExternal ? (
                <a
                  key={QuickAccess.id}
                  href={QuickAccess.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="font-bold text-sm text-white">
                    {QuickAccess.title}
                  </span>
                </a>
              ) : (
                <Link key={QuickAccess.id} href={QuickAccess.url}>
                  <span className="font-bold text-sm text-white">
                    {QuickAccess.title}
                  </span>
                </Link>
              )
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-4 w-full sm:w-[47%] mid:!w-[40%]">
          <Title level={2} className="H2 xl:!text-2xl whiteColor-text">
            اطلاعات تماس
          </Title>
          {contactInfo.map((info) => {
            const Icon = info.icon;
            return (
              <div key={info.id} className="flex gap-2 w-full items-center">
                <div className="w-8 h-8 rounded-xl bg-regal-light flex justify-center items-center shrink-0
                ">
                  <Icon className="text-[var(--color-regal-gold)]" />
                </div>
                <div className="flex items-center gap-4">
                  {(Array.isArray(info.title)
                    ? info.title
                    : [info.title]
                  ).map((title, index) => (
                    <React.Fragment key={`${info.id}-${index}`}>
                      {index > 0 && (
                        <div className="bg-white w-[1px] h-3.5" />
                      )}
                      <Link
                        href={
                          Array.isArray(info.link)
                            ? info.link[index]
                            : info.link
                        }
                      >
                        <Title
                          level={2}
                          className="H3 !font-normal !text-md flex-1 whiteColor-text"
                        >
                          {title}
                        </Title>
                      </Link>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
        <div className="w-full sm:w-[45%]">
          <MembershipForm />
        </div>
        <div className="flex flex-col gap-8 w-full sm:w-[47%] mid:!w-[40%]">
          <div className="grid grid-cols-4 xs:grid-cols-5 gap-2.5 w-full justify-center xs:justify-start items-center flex-wrap ">
            {PermissionsContents.map((permissions , index) => (
              <div
                key={permissions.id}
                className={`flex justify-center items-center  max-w-full max-h-full basis-1/4  rounded-lg bg-white  xs:order-none ${index === PermissionsContents.length - 1 ? "order-[-1] col-span-4 xs:col-span-1  aspect-auto " : "order-none col-span-1 aspect-square"}`}
              >
                {permissions.link ? (
                  <Link href={permissions.link} target="_blank" rel="noopener noreferrer">
                    {permissions.title === "enamad" ? (
                      <EnamadBadge />
                    ) : (
                      <>
                        {permissions.mobileUrl ? (
                          <>
                            <Image
                              src={permissions.url}
                              width={72}
                              height={72}
                              className="w-full h-full hidden xs:block"
                              alt={permissions.title}
                            />
                            <Image
                              src={permissions.mobileUrl}
                              width={72}
                              height={72}
                              className="w-full h-full block xs:hidden"
                              alt={permissions.title}
                            />
                          </>
                        ) : (
                          <Image
                            src={permissions.url}
                            width={72}
                            height={72}
                            className="w-full h-full"
                            alt={permissions.title}
                          />
                        )}
                      </>
                    )}
                  </Link>
                ) : permissions.title === "enamad" ? (
                  <EnamadBadge />
                ) : (
                  <>
                    {permissions.mobileUrl ? (
                      <>
                        <Image
                          src={permissions.url}
                          width={72}
                          height={72}
                          className="w-full h-full hidden xs:block"
                          alt={permissions.title}
                        />
                        <Image
                          src={permissions.mobileUrl}
                          width={72}
                          height={72}
                          className="w-full h-full block xs:hidden"
                          alt={permissions.title}
                        />
                      </>
                    ) : (
                      <Image
                        src={permissions.url}
                        width={72}
                        height={72}
                        alt={permissions.title}
                        className="w-full h-full"
                      />
                    )}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-between items-center w-full">
          <span className="text-xs text-regal-gray-light w-full">
            © کلیه حقوق برای تابرق محفوظ است.
          </span>
          <div className="flex gap-2 flex-1 w-full items-center justify-end">
            {SocialMediaContents.map((socialMedia) => (
              <Link
                key={socialMedia.id}
                href={socialMedia.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="flex items-center justify-center w-8 h-8">
                  {socialMedia.icon}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
